import { Segment } from 'crm-index-visualization-core';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { isOfMinSearchLength } from 'crm_data/elasticSearch/ElasticSearchValidation';
import { SYNC_SEARCH_TERM } from '../search/actions/searchActionTypes';
import { VIEW_PIPELINE_CHANGED, SORT_CHANGED, QUICK_FILTERS_CHANGED, QUICK_FILTER_PROPERTIES_CHANGED, FILTER_GROUPS_CHANGED } from '../../views/actions/viewsActionTypes';
import { toSortDirection } from './utils';
import { PIPELINE_CHANGED } from '../pipelines/slice/currentPipelineIdSlice';
import { RESTORE_CACHED_VALUES } from '../init/actions/initActionTypes';
import { ALL_PIPELINES_VALUE } from '../pipelines/constants/AllPipelinesValue';

/**
 * Pure reducer function for a segment that doesn't use immer
 * Can be used as a standalone reducer for testing or compatibility
 */
export const segmentReducer = (state = new Segment(), action) => {
  switch (action.type) {
    case SYNC_SEARCH_TERM:
      {
        const {
          searchTerm
        } = action.payload;
        const isValid = isOfMinSearchLength(searchTerm) || !searchTerm;
        return isValid ? state.with({
          search: searchTerm
        }) : state;
      }
    case VIEW_PIPELINE_CHANGED:
    case PIPELINE_CHANGED:
      {
        const {
          pipelineId
        } = action.payload;
        return state.with({
          pipelineId: pipelineId === ALL_PIPELINES_VALUE ? null : pipelineId
        });
      }
    case SORT_CHANGED:
      {
        const {
          sortColumnName,
          order
        } = action.payload;

        // Create a new sort object in the format expected by viz-core
        const newSort = {
          property: sortColumnName,
          order: toSortDirection(order)
        };

        // Update the segment with the new sort
        return state.with({
          sorts: [newSort]
        });
      }
    case QUICK_FILTERS_CHANGED:
      {
        const {
          quickFilters
        } = action.payload;
        return state.with({
          quickFilters
        });
      }
    case QUICK_FILTER_PROPERTIES_CHANGED:
      {
        const {
          quickFilterProperties
        } = action.payload;
        return state.with({
          quickFilterProperties
        });
      }
    // case FILTER_CHANGED is legacy and should be removed
    case FILTER_GROUPS_CHANGED:
      {
        const {
          filterGroups
        } = action.payload;

        // FilterGroups in viz-core only have the 'filters' property
        // Make sure the incoming filterGroups match this structure
        const advancedFilterGroups = filterGroups.map(group => ({
          filters: group.filters
        }));
        return state.with({
          advancedFilterGroups
        });
      }
    case RESTORE_CACHED_VALUES:
      {
        var _restoreView$filterGr, _restoreView$filterGr2;
        const {
          searchTerm,
          views,
          viewId,
          hasData
        } = action.payload;
        if (!hasData) {
          return state;
        }
        const restoreView = views[viewId];
        if (!restoreView) {
          return state;
        }
        const advancedFilterGroups = (_restoreView$filterGr = (_restoreView$filterGr2 = restoreView.filterGroups) === null || _restoreView$filterGr2 === void 0 ? void 0 : _restoreView$filterGr2.map(group => ({
          filters: group.filters
        }))) !== null && _restoreView$filterGr !== void 0 ? _restoreView$filterGr : [];
        return state.with({
          search: searchTerm,
          sorts: [{
            property: restoreView.state.sortColumnName,
            order: toSortDirection(restoreView.state.order)
          }],
          quickFilters: restoreView.quickFilters,
          quickFilterProperties: restoreView.quickFilterProperties,
          advancedFilterGroups
        });
      }
    default:
      return state;
  }
};

/**
 * Reduces an array of actions against a segment to produce an updated segment
 */
export const reduceActionsToSegment = (segment, actions) => {
  // Apply our traditional reducer to each action in sequence
  return actions.reduce((state, action) => {
    return segmentReducer(state, action);
  }, segment);
};